import React from 'react';
import Dialog from '@smart-tv/components/dialog';
import FeedbackDialog from '@smart-tv/components/feedback-dialog';
import PlayerDevicesContext from '../player-devices-context';
import PlayerDevicesDialogHomeScreen from './player-devices-dialog-home-screen';
import PlayerDevicesDialogEditScreen from './player-devices-dialog-edit-screen';

const screenMapper = {
  HOME: PlayerDevicesDialogHomeScreen,
  EDIT: PlayerDevicesDialogEditScreen
};

export const PlayerDevicesDialog: React.FC = () => {
  const { devices, handleClose, selectedScreen, openFeedbackDialog, handleCloseFeedbackDialog } =
    React.useContext(PlayerDevicesContext);

  if (!devices) return null;

  const PlayerDevicesDialogScreen = screenMapper[selectedScreen];

  return (
    <Dialog open={true} onClose={handleClose} showCloseButton={false}>
      <PlayerDevicesDialogScreen />

      <FeedbackDialog
        message="Enhed fjernet"
        open={openFeedbackDialog}
        onClose={handleCloseFeedbackDialog}
      />
    </Dialog>
  );
};

export default PlayerDevicesDialog;
